import { type ReactElement, type ReactNode } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '@/lib/auth'
import { Button } from '@/components/ui/button'

export function PublicLayout({ children }: { children: ReactNode }): ReactElement {
  const { user } = useAuth()
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-40 border-b border-border/60 bg-background/85 backdrop-blur">
        <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-6">
          <Link to="/" className="flex items-center gap-2">
            <span className="font-display text-2xl tracking-tight text-primary">MyPivot</span>
          </Link>
          <nav className="hidden gap-8 text-sm tracking-wide text-muted-foreground md:flex">
            <a href="#services" className="hover:text-foreground">
              Services
            </a>
            <a href="#produits" className="hover:text-foreground">
              Produits
            </a>
            <a href="#vision" className="hover:text-foreground">
              Vision
            </a>
            <a href="#contact" className="hover:text-foreground">
              Contact
            </a>
          </nav>
          <div className="flex items-center gap-3">
            {user ? (
              <Button
                size="sm"
                onClick={() => navigate(user.role === 'ADMIN' ? '/admin' : '/client')}
              >
                Espace {user.role === 'ADMIN' ? 'admin' : 'client'}
              </Button>
            ) : (
              <>
                <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground">
                  Se connecter
                </Link>
                <Button size="sm" onClick={() => navigate('/signup')}>
                  Devenir client
                </Button>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer id="contact" className="border-t border-border/60 bg-primary text-primary-foreground">
        <div className="mx-auto grid w-full max-w-7xl gap-10 px-6 py-14 md:grid-cols-4">
          <div className="md:col-span-2">
            <span className="font-display text-3xl">MyPivot</span>
            <p className="mt-4 max-w-md text-sm text-primary-foreground/70">
              Rendre l'impossible possible. L'art du provisioning sur la Côte d'Azur. De Monaco à
              Saint-Tropez, votre conciergerie ultra-personnalisée.
            </p>
          </div>
          <div>
            <h4 className="mb-3 text-xs uppercase tracking-widest text-accent">Contact</h4>
            <a
              href="mailto:contact@mypivotofficial.com"
              className="text-sm text-primary-foreground/80 hover:underline"
            >
              contact@mypivotofficial.com
            </a>
            <p className="text-sm text-primary-foreground/80">WhatsApp 24/7</p>
          </div>
          <div>
            <h4 className="mb-3 text-xs uppercase tracking-widest text-accent">Zone</h4>
            <p className="text-sm text-primary-foreground/80">Monaco · Cap d'Antibes</p>
            <p className="text-sm text-primary-foreground/80">Saint-Tropez · Cap Ferrat</p>
          </div>
        </div>
        <div className="border-t border-primary-foreground/10 py-4 text-center text-xs text-primary-foreground/50">
          © {new Date().getFullYear()} MyPivot — Tous droits réservés
        </div>
      </footer>
    </div>
  )
}
